export enum ShadowProfileEnum { 
    SALEPROFILE,
    SALEACCOUNT,
    LEADS,
    OPPORTUNITY,
    LEADS_VENUE
}